export const routes = [
  {
    path: '/',
    name: 'accueil',
    meta: {
      title: 'Trouvez un assistant maternel !',
      description: 'Recherchez votre future assistante maternelle à Angers et dans le Maine-et-Loire à l’aide des filtres et trouvez celle qui vous correspond.'
    },
    component: () => import('../views/Recherche.vue')
  },
  {
    path: '/ma-selection',
    name: 'selection',
    meta: {
      title: 'Ma sélection',
      description: 'Retrouvez la liste des assistants maternels que vous avez sélectionnés dans le Maine-et-Loire.'
    },
    component: () => import('../views/Selection.vue')
  },
  { 
    path: "*",
    name: '404',
    meta: {
      title: 'Page non trouvée',
      description: 'La page que vous cherchez sur assmat.maine-et-loire.fr n’existe pas ou a été supprimée.'
    },
    component: () => import('../views/404.vue')
  },
  {
    path: '/assmat/:userId',
    name: 'assmat',
    meta: {
      title: 'Fiche assmat',
      sitemap: {
        ignoreRoute: true
      },
      description: 'Géolocalisez votre future assistante maternelle avec sa présentation, ses expériences, ses qualifications, ses coordonnées et ses disponibilités.'
    },
    component: () => import('../views/FicheAssmat.vue'),
    props: true
  }
]